import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { type Theme } from 'loot-core/types/prefs';

import {
  themeOptions,
  useTheme,
} from '../../style/theme';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Text } from '../common/Text';

import { Setting } from './UI';

export function ThemeSettings() {
  const { t } = useTranslation();
  const [theme, switchTheme] = useTheme();

  return (
    <Setting
      primaryAction={
        <Select value={theme} onValueChange={value => switchTheme(value as Theme)}>
          <SelectTrigger className="w-[160px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {themeOptions.map(([value, label]) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      }
    >
      <Text>
        <Trans>
          <strong>Theme</strong> — choose Dark, Light, or System default.
        </Trans>
      </Text>
    </Setting>
  );
}
